import { callFunction } from "./functions-client";

// Compliance Document Vault / Carrier Packet (LOS Phase 20).
export const DOC_TYPES = [
  "insurance_coi", "surety_bond", "w9", "operating_authority", "cdl", "medical_card", "ifta", "drug_consortium", "other",
] as const;
export type DocType = (typeof DOC_TYPES)[number];

export const DOC_TYPE_LABELS: Record<DocType, string> = {
  insurance_coi: "Insurance (COI)",
  surety_bond: "Surety bond (BMC-84)",
  w9: "W-9",
  operating_authority: "Operating authority (MC/DOT)",
  cdl: "CDL",
  medical_card: "DOT medical card",
  ifta: "IFTA license",
  drug_consortium: "Drug & alcohol consortium",
  other: "Other",
};

export type ExpiryStatus = "valid" | "expiring_soon" | "expired" | "no_expiry";

export interface ComplianceDoc {
  id: string;
  doc_type: DocType;
  title: string | null;
  issued_at: string | null;
  expires_at: string | null;
  verified: boolean;
  status: ExpiryStatus;
  view_url: string | null;
}

export const listComplianceDocs = () =>
  callFunction<{ documents: ComplianceDoc[] }>("compliance/list", { method: "GET" });

export const createComplianceDoc = (input: { doc_type: DocType; title?: string; issued_at?: string; expires_at?: string; ext?: string }) =>
  callFunction<{ document: ComplianceDoc; path: string; upload_url: string }>("compliance/create", { body: input });

export const updateComplianceDoc = (input: { id: string; title?: string; issued_at?: string; expires_at?: string }) =>
  callFunction<{ ok: boolean }>("compliance/update", { body: input });

export const deleteComplianceDoc = (id: string) =>
  callFunction<{ ok: boolean }>("compliance/delete", { body: { id } });

export const carrierPacketLink = () =>
  callFunction<{ token: string; path: string }>("compliance/packet-link", { method: "POST" });

export interface PublicPacketDoc { doc_type: DocType; title: string | null; issued_at: string | null; expires_at: string | null; verified: boolean; status: ExpiryStatus }
export const publicPacket = (token: string) =>
  callFunction<{ carrier: string; documents: PublicPacketDoc[] }>(`compliance/public-packet?token=${encodeURIComponent(token)}`, { method: "GET" });
